import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	width: 100%;
	height: 629px;
	background-color: #000000;
`;

export { StyledContainer };
